import { render, staticRenderFns } from "./ServiceProviderServiceDetail.vue?vue&type=template&id=bbd27d78&"
import script from "./ServiceProviderServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports